<template>
<w-sliding-popup ref="slidingPopup" title="제어 스크립트 목록" top="50px" width="900px" :default-content="false" @close="onClose">
  <div slot="content" style="height:100%;">
    <div style="height:100%;" class="body-content-no-scroll" v-show="!(componentMode === 'update' || componentMode === 'add')">
      <el-row class="title-bar vertical-center-boc" type="flex" justify="start">
        <div class="title-h4 mr-r15">제어 스크립트 목록</div>
        <div class="setting-addel">
          <el-button size="mini" icon="fas fa-plus" @click="onAddCtrlScript"></el-button>
          <el-button size="mini" icon="fas fa-minus" @click="onDelCtrlScript" :disabled="selectedRowArray.length === 0"></el-button>
        </div>
      </el-row>
      <el-table height="calc(100% - 38px)" :data="scriptTableData" style="width: 100%" default-expand-all @selection-change="changeHandleSelection">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div style="padding:15px; width: 100%;">
              {{props.row.scriptContents}}
            </div>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="스크립트 아이디" prop="scriptId">
        </el-table-column>
        <el-table-column label="스크립트명" prop="scriptName">
        </el-table-column>
        <el-table-column label="수정" width="70px">
          <template slot-scope="scope">
            <i class="el-icon-edit" style="cursor: pointer;" @click="onClickEditButton(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="body-include-footer" v-show="(componentMode === 'update' || componentMode === 'add')">
      <div class="body-content" style="height:100%;">
        <w-control-script-set-component style="height:100%;" ref="ControlScriptSetComponent" @on-back-to-home-button="onBackToHomeButton" @load-data="loadData" :obj="obj" :component-mode="componentMode"></w-control-script-set-component>
      </div>
      <el-row type="flex" justify="center" class="el-dialog__footer">
        <el-button class="mr-r4" type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
        <el-button size="large" @click="componentMode = ''">취소</el-button>
      </el-row>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import commonAPI from '@/api/performance/common';
import msgUtil from '@/utils/message';
import WControlScriptSetComponent from './ControlScriptSetComponent';

export default {
  name: 'WControlScriptSettingPopup',
  components: {
    WControlScriptSetComponent,
  },
  props: {
    obj: {
      type: Object,
    },
  },
  data() {
    return {
      componentMode: '',
      selectedRowArray: [],
      scriptTableData: [],
      componentSetFlag: false,
    };
  },
  methods: {
    open() {
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    loadData() {
      this.selectedRowArray = [];
      commonAPI
        .getCtrlScriptSet({
          managetypeId: this.obj.objManagetypeId,
        })
        .then((response) => {
          if (response.data.success) {
            this.scriptTableData = response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '제어 스크립트 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '제어 스크립트 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClose() {
      this.componentMode = '';
      this.$emit('reload');
      this.$refs.slidingPopup.visible = false;
    },
    // row - 수정버튼 클릭
    onClickEditButton(row) {
      this.componentMode = 'update';
      this.$nextTick(() => {
        this.$refs.ControlScriptSetComponent.componentSetData(row);
      });
    },
    // 제어스크립트 추가화면 전환
    onAddCtrlScript() {
      this.componentMode = 'add';
      this.$nextTick(() => {
        this.$refs.ControlScriptSetComponent.componentSetData();
      });
    },
    // 제어스크립트 삭제
    onDelCtrlScript() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const target = '제어 스크립트';
        const action = msgUtil.action.DELETE;
        commonAPI
          .deleteCtrlScriptSet(this.selectedRowArray)
          .then((res) => {
            if (res.data.success) {
              this.loadData();
              this.$message(msgUtil.getResultMsgData(action, target, true));
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    onBackToHomeButton() {
      this.componentMode = '';
    },
    onSaveButtonClick() {
      this.$refs.ControlScriptSetComponent.onSaveButtonClick();
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ControlScriptSettingPopup.vue